shadow$provide[301] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Compose:{enumerable:true, get:function() {
  return Compose;
}}});
var require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js = require("../../primitive.js");
class Compose extends require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive {
  static initClass() {
    this.traits = ["node", "bind", "object", "visible", "operator", "style", "compose",];
    this.defaults = {zWrite:false, zTest:false, color:"#ffffff",};
  }
  init() {
    return this.compose = null;
  }
  resize() {
    if (!this.compose || !this.bind.source) {
      return;
    }
    const dims = this.bind.source.getActiveDimensions();
    const {width} = dims;
    const {height} = dims;
    return this.remapUVScale.set(width, height);
  }
  make() {
    this._helpers.bind.make([{to:"operator.source", trait:"source"}]);
    if (this.bind.source == null) {
      return;
    }
    const resampleUniforms = {remapUVScale:this._attributes.make(this._types.vec2()),};
    this.remapUVScale = resampleUniforms.remapUVScale.value;
    let fragment = this._shaders.shader();
    const {alpha} = this.props;
    if (this.bind.source.is("image")) {
      fragment.pipe("screen.pass.uv", resampleUniforms);
      fragment = this.bind.source.imageShader(fragment);
    } else {
      fragment.pipe("screen.map.xy", resampleUniforms);
      fragment = this.bind.source.sourceShader(fragment);
    }
    if (!alpha) {
      fragment.pipe("color.opaque");
    }
    const composeUniforms = this._helpers.style.uniforms();
    this.compose = this._renderables.make("screen", {map:fragment, uniforms:composeUniforms, linear:true,});
    this._helpers.visible.make();
    return this._helpers.object.make([this.compose]);
  }
  made() {
    return this.resize();
  }
  unmake() {
    this._helpers.bind.unmake();
    this._helpers.visible.unmake();
    return this._helpers.object.unmake();
  }
  change(changed, _touched, _init) {
    if (changed["operator.source"] || changed["compose.alpha"]) {
      return this.rebuild();
    }
  }
}
Compose.initClass();

};